<template>
  <div class="resultado_avaliacao">
    <!--Stats cards-->
    <h4 class="title"> {{ resultEvaluation.evaluation_cycle_name }} - {{ resultEvaluation.evaluation_type_name }}
      <small>{{ resultEvaluation.evaluation_cycle_start_date | formatDateBr }} - {{
        resultEvaluation.evaluation_cycle_end_date | formatDateBr }}</small>
    </h4>

    <div class="row" style="margin-top:20px;">
      <div class="col-lg-12 col-sm-12">
        <circle-chart-card :percentage="resultEvaluation.final_result" title="RESULTADO FINAL"
          :description="resultEvaluation.evaluation_type_name"
          :color="percentTotalColor(resultEvaluation.final_result)">
        </circle-chart-card>
      </div>
    </div>

    <div class="row" style="margin-top:20px;" v-if="!resultEvaluation.blocked">
      <div class="col-lg-6 col-sm-6">
        <circle-chart-card :percentage="resultEvaluation.total_skill_percent" title="COMPETÊNCIAS"
          :color="percentTotalColor(resultEvaluation.total_skill_percent)">
        </circle-chart-card>
      </div>
      <div class="col-lg-6 col-sm-6">
        <circle-chart-card :percentage="resultEvaluation.delivery_percent" title="ENTREGA"
          :color="percentTotalColor(resultEvaluation.delivery_percent)">
        </circle-chart-card>
      </div>
    </div>

    <div class="row" v-if="!resultEvaluation.blocked">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-header text-center">
            <h5 class="card-title" style="color: #252422; font-weight: 700;">RESULTADO</h5>
            <p class="category" style="color: #3b4651; font-size: 12px;">Competências</p>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-sm-12">
        <stats-card>
          <div class="icon-big text-center" slot="header">
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p class="category">COMPETÊNCIAS</p>
          </div>
          <div class="stats" slot="footer">
            <div v-for="(skill, index) in resultEvaluation.skills" :key="`skill-${index}`">
              <div class="row">
                <div class="col-xs-10 comp">
                  {{ skill.name }}
                </div>
                <div class="col-xs-2 grade_comp">
                  {{ skill.percent }}%
                </div>
              </div>
              <p-progress :value="skill.percent" :type="percentColor(skill.percent)"></p-progress>
            </div>
          </div>
        </stats-card>
      </div>
    </div>

    <div class="row" v-if="resultEvaluation.open_answer">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-header text-center">
            <h5 class="card-title" style="color: #252422; font-weight: 700;">RESPOSTA ABERTA</h5>
          </div>
          <div class="card-body" style="padding: 20px;">
            <p style="text-align: justify;">{{ resultEvaluation.open_answer.answer }}</p>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="resultEvaluation.evaluation_type_id == 1">
      <div class="col-lg-12 col-md-12">
        <div class="card card-plano-acao">
          <div class="card-header">
            <h4 class="card-title">PLANO DE AÇÃO</h4>
            <p class="category">Plano de Desenvolvimento proposto por seu Gestor Imediato para a competência
              selecionada.</p>
          </div>
          <div class="card-content">
            <el-collapse v-if="resultEvaluation.plan">
              <el-collapse-item :title="`${resultEvaluation.plan.development_plan_name} | ${translateStatus(resultEvaluation.plan.status)}`" name="1">
                <div>
                  <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Início:</b> {{ resultEvaluation.plan.start_date |
                  formatDateBr }}<br />
                  <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Término:</b> {{ resultEvaluation.plan.end_date |
                  formatDateBr }}<br /><br />

                  <div>
                    <i class="ti-ticket"></i>&nbsp;&nbsp;<b>Competência:</b><br />
                    <span v-for=" skill in resultEvaluation.plan.newSkills" style="font-size: 14px;">
                      <u>{{ skill.skill && skill.skill.name ? skill.skill.name : skill.name }}</u><br />
                      {{ skill.skill && skill.skill.description ? skill.skill.description : skill.description
                      }}<br /><br />
                    </span> <br />
                  </div>

                  <div v-if="resultEvaluation.plan.description">
                    <i class="ti-clipboard"></i>&nbsp;&nbsp;<b>Descrição:</b><br />
                    <div style="text-align: justify;"> {{ resultEvaluation.plan.description }} </div><br />
                  </div>

                  <div v-if="resultEvaluation.plan.action_plan_objective">
                    <i class="ti-star"></i>&nbsp;&nbsp;<b>Objetivo:</b><br />
                    <div style="text-align: justify;"> {{ resultEvaluation.plan.action_plan_objective }} </div><br />
                  </div>


                  <div v-if="resultEvaluation.plan.identified_improvement_areas">
                    <i class="ti-bookmark"></i>&nbsp;&nbsp;<b>Áreas de Melhoria:</b><br />
                    <div style="text-align: justify;"> {{ resultEvaluation.plan.identified_improvement_areas }} </div>
                    <br />
                  </div>

                  <div v-if="resultEvaluation.plan.action_plan_goals_old">
                    <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br />
                    <div style="text-align: justify;"> {{ resultEvaluation.plan.action_plan_goals_old }} </div><br />
                  </div>

                  <div v-else-if="resultEvaluation.plan.action_plan_goals && resultEvaluation.plan.action_plan_goals.length != 0">
                    <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br/>

                    <div 
                      v-for="(goal, index) in resultEvaluation.plan.action_plan_goals" 
                      :key="goal.id" 
                      class="goal"
                      style="margin-top: 10px; margin-bottom: 15px;"
                    >
                      <!-- <div class="panel-heading">
                        <h6>Meta {{ index + 1 }}</h6>
                      </div> -->
                      <div class="goal-title">
                        <span class="dot">•</span>
                        <b>Meta {{ index + 1 }}</b>
                        <span>-</span>
                        <span>{{ translateStatus(goal.status) }}</span>
                        <span>-</span>
                        <span>{{ goal.progress }}%</span>
                      </div>

                      <div class="goal-body">
                        <!-- Barra de progresso -->
                        <div class="progress" style="margin-bottom: 10px; height: 5px;">
                          <div 
                            class="progress-bar" 
                            role="progressbar"
                            :aria-valuenow="goal.progress"
                            aria-valuemin="0" 
                            aria-valuemax="100"
                            :style="'width: ' + goal.progress + '%;'"
                          >
                            <!-- {{ goal.progress }}% -->
                          </div>
                        </div>

                        <b>Descrição:</b> {{ goal.goal }}</br>
                        <b>Estratégia:</b> {{ goal.strategy }}</br>
                        <b>Prazo:</b> {{ formatDate(goal.due_date) }}
                        <!-- <p v-if="goal.due_date">
                        </p> -->
                      </div>
                    </div>
                  </div>

                  <div v-if="resultEvaluation.plan.strategies_to_reach_goals_old">
                    <i class="ti-list"></i>&nbsp;&nbsp;<b>Estratégias para Alcançar as Metas:</b><br />
                    <div style="text-align: justify;"> {{ resultEvaluation.plan.strategies_to_reach_goals_old }} </div>
                    <br />
                  </div>

                  <div v-if="resultEvaluation.plan.success_indicators && resultEvaluation.plan.success_indicators.length > 0">
                    <i class="ti-stats-up"></i>&nbsp;&nbsp;<b>Indicadores de Sucesso:</b><br />
                    <div v-for=" successIndicator in resultEvaluation.plan.success_indicators">
                      <div style="text-align: justify;"> - {{ successIndicator.success_indicator.description }} </div>
                    </div><br />
                  </div>

                  <div v-if="resultEvaluation.plan.monitoring_meetings && resultEvaluation.plan.monitoring_meetings.length > 0">
                    <i class="ti-timer"></i>&nbsp;&nbsp;<b>Acompanhamento:</b><br/>
                    <div style="text-align: justify;">
                      Próxima reunião: {{ formatNextMonitoring(resultEvaluation.plan.next_monitoring) }}
                    </div></br>

                    <i class="ti-agenda"></i>&nbsp;&nbsp;<b>Histórico de Reuniões:</b><br/>
                    <div v-if="pastMeetings.length && pastMeetings.length > 0" class="carousel-wrapper">
                      <!-- Botão anterior -->
                      <button class="nav-button left" @click="prevMeeting" :disabled="currentMeetingIndex === 0"><i class="ti-angle-left"></i></button>

                      <!-- Card da reunião com transição -->
                      <transition :name="slideDirection" mode="out-in">
                        <div class="carousel-card" :key="currentPastMeeting.id">
                          <b>Data:</b> {{ formatDate(currentPastMeeting.date) }}<br>
                          <div v-if="currentPastMeeting.status === 2">
                            <span>Reunião não realizada.</span>
                          </div>
                          <div v-else>
                            <div v-for="goalProgress in currentPastMeeting.goal_progresses">
                              <div v-if="goalProgress.progress_change > 0">
                                <i class="ti-arrow-up"></i>
                                <b>
                                  <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                  <span v-else>Meta:</span>
                                </b>
                                <span style="color: green;"> + {{ goalProgress.progress_change }}%</span>
                                <span>{{ goalProgress.action_plan_goal.goal }}</span>
                              </div>
                              <div v-else-if="goalProgress.progress_change == 0">
                                <b>
                                  <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                  <span v-else>Meta:</span>
                                </b>
                                <span> + {{ goalProgress.progress_change }}%</span>
                                <span>{{ goalProgress.action_plan_goal.goal }}</span>
                              </div>
                              <div v-else>
                                <i class="ti-arrow-down"></i>
                                <b>
                                  <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                  <span v-else>Meta:</span>
                                </b>
                                <span style="color: red;"> - {{ goalProgress.progress_change * (-1) }}%</span>
                                <span>{{ goalProgress.action_plan_goal.goal }}</span>
                              </div>
                            </div>
                            <b>Feedbacks:</b> {{ currentPastMeeting.feedbacks }}<br>
                          </div>
                        </div>
                      </transition>

                      <!-- Botão próximo -->
                      <button class="nav-button right" @click="nextMeeting" :disabled="currentMeetingIndex >= pastMeetings.length - 1"><i class="ti-angle-right"></i></button>
                      <div class="carousel-indicators">
                        <span
                          v-for="(meeting, index) in pastMeetings"
                          :key="meeting.id"
                          :class="['indicator-dot', { active: index === currentMeetingIndex }]"
                          @click="goToMeeting(index)"
                        ></span>
                      </div>
                    </div>
                    <div v-else style="text-align: justify;">
                      As reuniões de acompanhamento realizadas aparecerão aqui.
                    </div><br />
                  </div>

                  <div v-else-if="resultEvaluation.plan.monitoring_frequencies.length > 0">
                    <i class="ti-timer"></i>&nbsp;&nbsp;<b>Frequência de Monitoramento:</b><br />
                    <div v-for=" monitoringFrequency in resultEvaluation.plan.monitoring_frequencies">
                      <div style="text-align: justify;"> - {{ monitoringFrequency.monitoring_frequency.description }}
                      </div>
                    </div><br />
                  </div>

                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-sm-12" style="text-align:center;margin:20px 0;">
        <router-link to="/avaliacao/listar">
          <button type="button" class="btn btn-wd btn-default btn-move-left"><span class="btn-label"><i
                class="ti-angle-left"></i></span>
            Voltar
          </button>
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import swal from 'sweetalert2'
  import moment from 'moment'

  export default {
    mounted () {
      this.evaluationId = this.$route.params.evaluationId
      this.getResultEvaluation()
    },
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      PProgress
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        evaluationId: null,
        resultEvaluation: {},
        currentMeetingIndex: 0
      }
    },
    filters: {
      formatDateBr (date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    methods: {
      getResultEvaluation () {
        let url = `/collaborator/result-evaluation/${this.evaluationId}`
        axios.get(url).then((res) => {
          this.resultEvaluation = res.data


          console.log('resultEvaluation.open_answer')
          console.log(this.resultEvaluation.open_anwswer)
        }).catch(error => {
          let message = 'Não foi possível completa requisição, tente novamente mais tarde.'

          if (error.response.status !== 500) {
            message = error.response.data.error
          }

          swal({
            title: 'Avaliação!',
            text: message,
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Voltar',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.$router.push(`/avaliacao/listar`)
          }).catch(swal.noop)
        })
      },
      percentColor (percent) {
        let classColor = 'success'

        if (percent >= 0 && percent < 40) {
          classColor = 'danger'
        } else if (percent >= 40 && percent < 80) {
          classColor = 'warning'
        }
        return classColor
      },
      percentTotalColor (percent) {
        let color = 'green'

        if (percent >= 0 && percent < 40) {
          color = 'red'
        }

        if (percent >= 40 && percent < 80) {
          color = 'orange'
        }

        return color
      },
      formatDate (dateStr) {
        if (!dateStr) return ''

        // Extrair apenas a parte da data (YYYY-MM-DD)
        const [datePart] = dateStr.split(' ')
        const [year, month, day] = datePart.split('-').map(Number)

        // Criar a data corretamente no fuso local
        const date = new Date(year, month - 1, day)

        return date.toLocaleDateString('pt-BR')
      },
      translateStatus (status) {
        const translations = {
          pending: 'Pendente',
          in_progress: 'Em Andamento',
          at_risk: 'Em Risco',
          completed: 'Concluído',
          overdue: 'Atrasado'
        }
        return translations[status] || status
      },
      formatNextMonitoring (nextMonitoring) {
        console.log('nextMonitoring', nextMonitoring)
        if (!nextMonitoring) {
          return 'NÃO AGENDADA'
        }
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')

        const formattedToday = `${year}-${month}-${day}`

        console.log('nextMonitoring.date', nextMonitoring.date)
        console.log('formattedToday', formattedToday)

        if (nextMonitoring.date === formattedToday) {
          return 'HOJE'
        } else {
          return this.formatDate(nextMonitoring.date)
        }
      },
      prevMeeting () {
        if (this.currentMeetingIndex > 0) {
          this.slideDirection = 'slide-right' // voltando: entra da esquerda
          this.currentMeetingIndex--
        }
      },
      nextMeeting () {
        if (this.currentMeetingIndex < this.pastMeetings.length - 1) {
          this.slideDirection = 'slide-left' // indo para frente: entra da direita
          this.currentMeetingIndex++
        }
      },
      goToMeeting (index) {
        if (index !== this.currentMeetingIndex) {
          this.slideDirection = index > this.currentMeetingIndex ? 'slide-left' : 'slide-right'
          this.currentMeetingIndex = index
        }
      }
    },
    computed: {
      pastMeetings () {
        return this.resultEvaluation.plan.monitoring_meetings.filter(m => m.status === 1 || m.status === 2).sort((a, b) => new Date(a.date) - new Date(b.date))
      },
      currentPastMeeting () {
        return this.pastMeetings[this.currentMeetingIndex]
      }
    }
  }

</script>
<style scoped>
.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: all 0.4s ease;
}

.slide-left-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.carousel-wrapper {
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px; /* espaço lateral pros botões */
}

.carousel-card {
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: white;

  max-height: 300px;
  overflow-y: auto;
  width: 100%; /* ocupa o espaço entre os botões */
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button.left {
  left: 10px;
}

.nav-button.right {
  right: 10px;
}

.nav-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.nav-button:disabled:hover {
  background: inherit;
  color: inherit;
}

.carousel-indicators {
  /* position: absolute; */
  bottom: -30px; /* pode ajustar esse valor conforme necessário */
  display: flex;
  justify-content: center;
  gap: 8px;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator-dot.active {
  background-color: #409EFF;
}
</style>
<style>
.grade_comp{
  text-align:right;
}
h5.card-title{margin-bottom:0 !important;}
.chart-circle {
    margin-top: 3px !important;
    margin-bottom: 17px !important;
}
.goal {
  border-left: 2px solid #a4b1c1;
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
.goal-title {
  /* background-color: #f5f5f5; */
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  gap: 10px;
}
.goal-body {
  /* background-color: #f5f5f5; */
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Evaluation/Overview.vue